import { hashQueryKey, useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect } from "react";

export const useIsTicketNewerThan = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (ticketId: string, updatedAt: number) =>
      (queryClient.getQueryState(["ticket", ticketId])?.dataUpdatedAt ?? 0) >
      updatedAt,
    [queryClient],
  );
};

export const useInvalidateEligibilityOnTicketFetch = ({
  mspId,
  ticketId,
  enabled,
}: {
  mspId: string;
  ticketId: string;
  enabled: boolean;
}) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled) return;
    const ticketQueryHash = hashQueryKey(["ticket", ticketId]);
    return queryClient.getQueryCache().subscribe((event) => {
      if (
        event.type !== "updated" ||
        event.action.type !== "success" ||
        event.action.manual ||
        event.query.queryHash !== ticketQueryHash
      ) {
        return;
      }
      queryClient.invalidateQueries(["agentEligibility", mspId, ticketId]);
    });
  }, [queryClient, enabled, mspId, ticketId]);
};
